export interface AddressSuggestionDisplayItem {
  formattedAddress?: string;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export function splitSuggestionLines(item: AddressSuggestionDisplayItem): {
  primary: string;
  secondary: string | null;
} {
  const street = item.street?.trim();
  const city = item.city?.trim();
  const state = item.state?.trim();
  const zip = item.zip?.trim();
  const structuredSecondary = [city, state, zip].filter(Boolean).join(", ") || null;

  if (street) {
    return { primary: street, secondary: structuredSecondary };
  }

  const formatted = item.formattedAddress?.trim() ?? "";
  const commaIndex = formatted.indexOf(",");
  if (commaIndex === -1) {
    return { primary: formatted, secondary: structuredSecondary };
  }

  return {
    primary: formatted.slice(0, commaIndex).trim(),
    secondary: formatted.slice(commaIndex + 1).trim() || structuredSecondary,
  };
}
